import { executeRequest, Request } from '@jfs/network'
import { actionMenuStrings } from '../../src/data/static/strings'
import { RootStore } from '../../src/data/store'
import { getCommaFormatedVal, isEmpty, updateEndDateTimeInRequest } from '../util/util'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = ({ data }: any) => {
  return [
    data?.totalRequestRecived ?? 'NA',
    data.totalTokenizedCount ?? 'NA',
    data.totalTokenizedTransaction ?? 'NA',
    isEmpty(data?.totalTokenizedTransactionAmount)
      ? 'NA'
      : `${getCommaFormatedVal(Number(data.totalTokenizedTransactionAmount ?? '0'), false)}`,
  ]
}

const getVaultSummary = (tokens: any, reqBody: any) => {
  const isCustomRange =
    RootStore.tokenizationRequests.summarySelectedDate.dateLabel === actionMenuStrings.customDate ||
    RootStore.tokenizationRequests.summarySelectedDate.dateLabel === 'custom'

  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.vaultSummary,
    body: isCustomRange
      ? reqBody
      : updateEndDateTimeInRequest(reqBody, RootStore.tokenizationRequests.summarySelectedDate),
    method: 'POST',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data?.data)
  })
}

export { getVaultSummary }
